/* -------------------------------------------------------------------------- */
/*                               Project types                                */
/* -------------------------------------------------------------------------- */

import { NOT_APPLICABLE } from '@config/constants/common';
import { COUNTRIES } from '@config/constants/countries';
import i18n from 'i18next';

/**
 * Retrieves the label associated with the specified country ID.
 * @param {string} id - The ID of the country to retrieve the label for.
 * @returns {string|null} The label of the country, or null if the country is not found.
 */
export const getCountryName = (code: string) => {
	const foundCountry = COUNTRIES.find(
		(country) => country.code === code
	);
	return (
		(foundCountry && i18n.t(`countries.${code}`)) ||
		NOT_APPLICABLE
	);
};
